<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/about">О компании
    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">О компании

    </h1>
    <h4>Компания "Протос Экспертиза" занимает лидирующие позиции на рынке услуг в сфере промышленной безопасности, что обеспечивается радом факторов:</h4>
    <ul class="marked ml-50">
      <li>В штате компании работают только высокопрофессиональные эксперты с многолетним опытом работы, как в других экспертных организациях, так и на промышленных объектах. Каждый эксперт обладает высокой степенью ответственности и увесистым багажом знаний и навыков, что в свою очередь позволяет нашим клиентам оформлять разрешительные документы в кратчайшие сроки.</li>
      <li>Список услуг непрерывно расширяется не только в области промышленной безопасности, но и в области юридического консалтинга, страхования, обучения персонала предприятий. А поэтому, мы можем комплексно решить целый ряд проблем предприятия с документацией. Все документы оформляются параллельно, что переводит наши отношения с клиентом в статус постоянных и надежных.</li>
      <li>Взаимодействие с Ростехнадзором в течение длительного времени, дает нам возможность решать сложнейшие задачи в срок и на высоком уровне.</li>
      <li>Мы ценим свою репутацию, а поэтому на начальных этапах общения с клиентом оговариваем весь перечень необходимых работ, сроки и конечную стоимость.</li>
      <li>Мы руководствуемся золотым правилом: стоимость услуг должна соответствовать их качеству, а поэтому наши цены всегда оптимальные и держаться &quot;в рынке&quot;.</li>
      <li>Специально разработанная система контроля качества &quot;Протос Гарант&quot;.</li>
    </ul>

    <p>Компания &laquo;Протос Экспертиза&raquo; более 20 лет специализируется на оказании услуг в области промышленной, экологической и пожарной безопасности. В соответствующих разделах сайта вы можете ознакомиться с интересующей вас информацией о той или иной услуге, а также оставить заявку на расчет стоимости.</p>

    <p>На настоящий момент число наших клиентов превышает несколько тысяч российских и зарубежных организаций - это компании производители оборудования, используемого на опасных производственных объектах; компании, которые эксплуатируют опасные производственные объекты, и компании, которые проводят экспертизу промышленной безопасности.</p>
    <div class="yellow-block w-100">
      Бизнес-сообщество выбирает группу компаний Протос, потому что мы любим свою работу и делаем её лучше всех!

    </div>
    <h2>Наши реквизиты:</h2>

    <p>ООО&nbsp;&quot;ПРОТОС ЭКСПЕРТИЗА&quot;</p>

    <p>ИНН:&nbsp;7707594915</p>

    <p>КПП:&nbsp;770801001</p>

    <p>Юр. адрес:&nbsp;107078, г. Москва, вн. тер. г. Муниципальный округ Красносельский, пер. Орликов, д.5, стр. 1А, эт. 1, комп. 125</p>

    <p>Почт. адрес:&nbsp;105064, Старая Басманная ул, д. 7, стр. 2, г. Москва</p>

    <app-reviews-block class="w-100"></app-reviews-block>
    <a class="underlined" routerLink="/otzyvy/">Все отзывы</a>
  </div>
</div>
<app-footer></app-footer>
